export const partnerDataTwo = [
  { title: "", something: "" },
  { more: "", day: "" },
  {
    contLeftTitle: `Worcester Bosch`,
    contLeftText: `Our commitment to the highest standards of manufacturing over the last 50 years, has led to us being consistently being recommended by Which? for both our gas and oil boiler ranges.`,
    leftImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643111300/AquaHeat/new%20images/Worcester-Bosch-boiler-1_joxzre.webp`,
  },
  {
    contRightTitle: "Hitatchi Capital",
    contRightText: `We provide market-leading point of sale retail finance, award-winning personal loans, and support the growth of UK business with a full service offering from asset finance to vehicle solutions.`,
    rightImgUrl: `https://res.cloudinary.com/duwmjod0j/image/upload/c_scale,q_80,w_580/v1643111462/AquaHeat/new%20images/hitachi_d47iiz.webp`,
  },
];
